<template>
  <div class="right-panel">
    <ul class="item-list">
      <li class="current-time">
        <p class="item-text" v-if="estimatesTime > 0">{{formatTime}}</p>
        <div class="circle">
          <canvas id="circle1" width="320" height="320"></canvas>
          <div class="center-text">
            <p class="num">{{formatShowTime}}</p>
            <p class="text">用时</p>
          </div>
        </div>
      </li>
      <template v-if="flowId != 15">
        <li v-if="isTest">
        <!-- <li v-if="true"> -->
          <div class="circle">
            <canvas id="circle2" width="320" height="320"></canvas>
            <div class="center-text">
              <p class="num">{{rightRate}}%</p>
              <p class="text">正答率</p>
            </div>
          </div>
        </li>
      </template>
    </ul>
    <!-- warning -->
    <warning :warning="warning" @popJumpAction="popJumpAction" @popGoOnAction="popGoOnAction" v-if="warning.isAnimate"></warning>
    <!-- warning end -->
  </div>
</template>
<script>
import { formatTime } from "@/utils";
import { mapGetters, mapActions } from "vuex";
import Warning from "@/components/Warning";
import {
  getUserLocalData,
} from "@/utils/auth";

export default {
  data() {
    return {
      flowId: '',
      showTime: 0,
      time: 0,
      warning: {
        isAnimate: false, // 提示动画
        status: "sad" // good 答对了 sad 打错了 over 超时了
      },
    };
  },
  components: {
    Warning
  },
  props: {
    estimatesTime: Number,
    rightRate: Number,
    currentPointNum: Number,
    totalPointNum: Number,
    isCancelTimeoutNotice: false
  },
  computed: {
    ...mapGetters(["qTime", "module", "showTimeoutNotice","shareData","moduleStatus"]),
    formatShowTime() {
      return formatTime(this.showTime);
    },
    formatTime() {
      return formatTime(this.estimatesTime);
    },
    lessonType() {
      let res = "学习";
      if (this.module.sModuleType === 1) {
        res = "测试";
      } else if (this.module.sModuleType === 2) {
        res = "学习";
      }

      return res;
    },
    isTest() {
      let res = false;
      console.log('this.module.sModule---', this.module.sModule)
      if (this.moduleStatus.current[0].sModule == 100001 || this.moduleStatus.current[0].sModule == 100050 || this.moduleStatus.current[0].sModule == 990000) {
        res = true;
      } else {
        res = false
      }
      // console.log('res-----', res)
      return res;
    },
  },
  mounted() {
    this.time = this.qTime;
    let { flowId } = getUserLocalData()
    this.flowId = flowId // 15 老流程
  },
  methods: {
    ...mapActions(["setQtime", "setTimeoutNotice"]),
    cancelTimeoutNotice() {
      this.setTimeoutNotice(false);
      this.$emit("cancelTimeoutNotice");
    },
    resetTimer() {
      this.setQtime(0);
      clearInterval(this.timer);
    },
    pauseTimer () {
      this.setQtime(this.time);
      if (this.timer) clearInterval(this.timer);
    },
    renderCircle() {
      this.renderCircle1();
      if (this.isTest && this.flowId != 15) {
        this.renderCircle2();
      }
    },
    renderCircle3 () {
      this.time = this.qTime;
      this.showTime = this.time;
      let canvas = document.getElementById("circle1");

      let ctx = canvas.getContext("2d");

      let x = canvas.width / 2,
        y = canvas.height / 2;

      let sAngle = -Math.PI / 2,
        eAngle = 2 * Math.PI - Math.PI / 2,
        r = 132,
        percent = 0;

      ctx.lineWidth = 16;

      const render = (start, end) => {
        ctx.clearRect(0, 0, 320, 320);
        ctx.lineWidth = 16;
        if (this.estimatesTime > 0) {
          ctx.strokeStyle = "#FDB550";
          // ctx.strokeStyle = "#f8f36e";

          if (this.time > this.estimatesTime) {
            ctx.strokeStyle = "#ffbf6b";
          }
          if (this.time > 3 * this.estimatesTime) {
            ctx.strokeStyle = "#fe714d";
          }
        }

        ctx.beginPath();
        ctx.arc(x, y, r, start, end);
        ctx.stroke();
        ctx.lineWidth = 8;
        ctx.strokeStyle = "rgba(255, 189, 123, .3)";
        ctx.beginPath();
        ctx.arc(x, y, r, end, 2 * Math.PI + start);
        ctx.stroke();

        ctx.lineWidth = 24;
        ctx.strokeStyle = "rgba(255, 189, 123, .06)";
        ctx.beginPath();
        ctx.arc(x, y, r+6, end, 2 * Math.PI);
        ctx.stroke();
      };

      ctx.strokeStyle = "#FFF37C";
      render(sAngle, sAngle);
    },
    renderCircle1() {
      this.time = this.qTime;
      let canvas = document.getElementById("circle1");

      let ctx = canvas.getContext("2d");

      let x = canvas.width / 2,
        y = canvas.height / 2;

      let sAngle = -Math.PI / 2,
        eAngle = 2 * Math.PI - Math.PI / 2,
        r = 132,
        percent = 0;

      ctx.lineWidth = 16;

      const render = (start, end) => {
        ctx.clearRect(0, 0, 320, 320);
        ctx.lineWidth = 16;
        if (this.estimatesTime > 0) {
          ctx.strokeStyle = "#FDB550";
          // ctx.strokeStyle = "#f8f36e";

          if (this.time > this.estimatesTime) {
            ctx.strokeStyle = "#ffbf6b";
          }
          if (this.time > 3 * this.estimatesTime) {
            ctx.strokeStyle = "#fe714d";
          }
        }

        ctx.beginPath();
        ctx.arc(x, y, r, start, end);
        ctx.stroke();
        ctx.lineWidth = 8;
        ctx.strokeStyle = "rgba(255, 189, 123, .3)";
        ctx.beginPath();
        ctx.arc(x, y, r, end, 2 * Math.PI + start);
        ctx.stroke();

        ctx.lineWidth = 24;
        ctx.strokeStyle = "rgba(255, 189, 123, .06)";
        ctx.beginPath();
        ctx.arc(x, y, r+6, end, 2 * Math.PI);
        ctx.stroke();
      };

      ctx.strokeStyle = "#FFF37C";
      render(sAngle, sAngle);

      if (this.timer) clearInterval(this.timer);
      this.timer = setInterval(() => {
        ++this.time;
        this.setQtime(this.time);
        this.showTime = this.time;
        if (this.estimatesTime > 0) {
          percent = this.time / this.estimatesTime;
          if (percent >= 1) {
            // let times = Math.floor(percent)
            // percent = percent - times
            eAngle = 2 * Math.PI - Math.PI / 2;
          } else {
            eAngle = percent * 2 * Math.PI - Math.PI / 2;
          }
          if (this.time > this.estimatesTime && this.time < this.estimatesTime + parseInt(5)) {
            let _this = this;
            this.warning.isAnimate = true;
            this.warning.status = "hurry";
            setTimeout(() => {
              _this.warning.isAnimate = false;
            }, 3000);
          }
          if (!this.isCancelTimeoutNotice && this.time > parseInt(2 * this.estimatesTime) ) {
            this.setTimeoutNotice(true);
            this.warning.isAnimate = true;
            this.warning.status = "sad";
//            let _this = this;
//             setTimeout(() => {
//              _this.warning.isAnimate = false;
//            }, 3000);
          }
//          if(this.time > parseInt(3 * this.estimatesTime) + parseInt(5)){
//            this.warning.isAnimate = false
//          }
          render(sAngle, eAngle);
        }
      }, 1000);
    },
    renderCircle2() {
      let canvas = document.getElementById("circle2");
      let x = canvas.width / 2,
        y = canvas.height / 2;
      let ctx = canvas.getContext("2d");
      let sAngle = -Math.PI / 2,
        eAngle = 0,
        r = 132;
      let percent = this.rightRate / 100;
      eAngle = percent * 2 * Math.PI - Math.PI / 2;

      ctx.lineWidth = 8;
      ctx.strokeStyle = "#9584FF";

      ctx.lineWidth = 16;
      ctx.strokeStyle = "#FFF363";

      ctx.clearRect(0, 0, 320, 320);
      ctx.beginPath();
      ctx.arc(x, y, r, sAngle, eAngle);
      ctx.stroke();
      ctx.lineWidth = 8;
      ctx.strokeStyle = "RGBA(246, 214, 186, 1)";
      ctx.beginPath();
      ctx.arc(x, y, r, eAngle, 2 * Math.PI + sAngle);
      ctx.stroke();
    },
    popJumpAction() {},
    popGoOnAction() {
       this.setTimeoutNotice(false);
      //  this.isCancelTimeoutNotice = true;
       this.$emit('cancelTimeoutNotice');
      this.warning.isAnimate = false;
    },
    showWarning(name) {}
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import '@/assets/css/theme/register.scss';
*,
:after,
:before {
  box-sizing: border-box;
}
.right-panel {
  // position: absolute;
  // top: 0;
  // right: -105px;
  display: flex;
  justify-content: center;
  text-align: center;
  margin-top: 30px;
  .item-list {
    list-style: none;
    background: $theme-rightcircle-bgcolor;
    border-radius: 100px;
    padding: 22px 8px 0;
    li {
      margin-bottom: 20px;
    }
    li:last-child {
      margin-bottom: 22px;
    }
    .current-time {
      position: relative;
      .timeout-notice {
        position: absolute;
        width: 200px;
        top: 20px;
        left: -220px;
        padding: 10px 10px 10px 40px;
        background: #ffffff;
        box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.15);
        border-radius: 4px;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        line-height: 24px;
        a {
          display: block;
          width: 100%;
          text-align: right;
          color: #5fa6b3;
          text-align: right;
          padding-right: 5px;
        }
        &:before {
          position: absolute;
          content: "";
          display: block;
          top: 14px;
          left: 15px;
          width: 16px;
          height: 16px;
          background: url("../assets/images/timeout_icon.png") no-repeat;
          background-size: 100%;
        }
        &:after {
          position: absolute;
          content: "";
          display: block;
          top: 10px;
          right: -10px;
          width: 0;
          border-width: 10px;
          border-style: solid;
          border-top-color: transparent;
          border-left-color: transparent;
          border-right-color: transparent;
          border-bottom-color: #ffffff;
          transform: rotate(-45deg);
        }
      }
    }
  }
  .item-text {
    font-size: 12px;
    font-weight: bold;
    color: $theme-rightcircle-text-color;
    text-align: center;
    line-height: 12px;
    margin-bottom: 5px;
  }
  .circle {
    position: relative;
    width: 80px;
    height: 80px;
    padding: 18px;
    border-radius: 50%;
    // background: $theme-rightcircle-time-bgcolor;
    /* box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.05); */
    canvas {
      position: absolute;
      top: 0;
      left: 0;
      width: 80px;
      height: 80px;
    }
    .center-text {
      position: absolute;
      top: 0;
      left: 0;
      width: 80px;
      height: 80px;
      padding-top: 25px;
      z-index: 2;
      .text {
        font-size: 12px;
        color: $theme-text-color-gray6;
        text-align: center;
        line-height: 12px;
        margin-bottom: 5px;
      }
      .num {
        font-size: 14px;
        font-weight: bold;
        color: $theme-text-color-gray;
        text-align: center;
        line-height: 14px;
        margin-bottom: 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RightCircle.vue